import * as fields from './fields';

export const SPANISH = 'SPANISH';

export const translateFieldNameToLanguage = (fieldName, language)=>{
    switch(language){
        case SPANISH:
            switch(fieldName){
                case fields.name:
                    return "Nombre";
                case fields.first_name:
                    return "Nombres";
                case fields.last_name:
                    return "Apellidos";
                case fields.username:
                    return "Nombre de usuario";
                case fields.email:
                    return "Email";
                case fields.phone_number:
                    return "Nro de Teléfono";
                case fields.document_number:
                    return "CI Nro";
                case fields.obs:
                    return "Observaciones";
                case fields.liters:
                    return "Litros";
                case fields.fueling_mileage:
                    return "Kilometraje de carga";
                case fields.bill_number:
                    return "Nro de factura";
                case fields.payment_method:
                    return "Forma de pago";
                case fields.brand:
                    return "Marca";
                case fields.consumption_100km:
                    return "Consumo 100km";
                case fields.datasheet:
                    return "Datasheet";
                case fields.activity:
                    return "Actividad";
                case fields.origin:
                    return "Origen";
                case fields.destination:
                    return "Destino";
                case fields.initial_mileage:
                    return "Km Inicial";
                case fields.final_mileage:
                    return "Km final";
                case fields.distance_traveled:
                    return "ΔKM";
                case fields.work_order:
                    return "OT";
                case fields.service_order:
                    return "Orden de servicio";
                case fields.has_external_owner:
                    return "Dueño externo";
                case fields.owner:
                    return "Dueño";
                case fields.identifier:
                    return "Identificador";
                case fields.model:
                    return "Modelo";
                case fields.plate_number:
                    return "Nro de chaoa";
                case fields.year:
                    return "Año";
                default:
                    return fieldName;
            }
        default:
            return fieldName;
    }
}